var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help_icon",
    "data-name": "help icon",
    transform: "translate(-13 -971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    transform: "translate(13 971)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_22",
    "data-name": "Subtraction 22",
    d: "M17437,18918h-17a2,2,0,0,1-2-2v-17a2,2,0,0,1,2-2h17a2,2,0,0,1,2,2v17A2,2,0,0,1,17437,18918Zm-8.58-6.428a1.162,1.162,0,0,0-1.291,1.33,1.407,1.407,0,0,0,.332,1,1.464,1.464,0,0,0,1.924-.01,1.407,1.407,0,0,0,.336-.986,1.349,1.349,0,0,0-.332-.979A1.278,1.278,0,0,0,17428.418,18911.572Zm.395-8.873a2.2,2.2,0,0,1,1.42.393,1.373,1.373,0,0,1,.488,1.135,1.9,1.9,0,0,1-.3,1.088,6.548,6.548,0,0,1-1.35,1.287,4.659,4.659,0,0,0-1.229,1.324,3.33,3.33,0,0,0-.352,1.609v.561h1.723v-.395a2.038,2.038,0,0,1,.275-1.135,5.28,5.28,0,0,1,1.1-1.062,9.6,9.6,0,0,0,1.348-1.211,3.1,3.1,0,0,0,.773-2.156,2.873,2.873,0,0,0-1.006-2.326,4.135,4.135,0,0,0-2.734-.846,7.8,7.8,0,0,0-3.822.992l.736,1.549a10.708,10.708,0,0,1,1.391-.57A4.93,4.93,0,0,1,17428.813,18902.7Z",
    transform: "translate(-17400 -17920)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.100b4d52.svg";
export { ForwardRef as ReactComponent };